import actionTypes from './actionTypes';

const INITIAL_STATE = {
  setNewPasswordLoading: false,
  setNewPasswordFailed: false,
  setNewPasswordReject: false,
  setNewPasswordMessage: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SET_NEW_PASSWORD_LOADING: {
      return {
        ...state,
        setNewPasswordLoading: true,
        setNewPasswordFailed: false,
        setNewPasswordReject: false,
        setNewPasswordMessage: [],
      };
    }
    case actionTypes.SET_NEW_PASSWORD_SUCCESS: {
      return {
        ...state,
        setNewPasswordLoading: false,
        setNewPasswordFailed: false,
        setNewPasswordReject: false,
        setNewPasswordMessage: [],
      };
    }
    case actionTypes.SET_NEW_PASSWORD_FAILED: {
      return {
        ...state,
        setNewPasswordLoading: false,
        setNewPasswordFailed: true,
        setNewPasswordReject: false,
        setNewPasswordMessage: [],
      };
    }
    case actionTypes.SET_NEW_PASSWORD_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        setNewPasswordLoading: false,
        setNewPasswordFailed: false,
        setNewPasswordReject: true,
        setNewPasswordMessage: message,
      };
    }

    default:
      return state;
  }
};
